// extracted by mini-css-extract-plugin
export var addToCartButton = "_ma-b";
export var arrowButtonContainer = "_ma-9";
export var arrowButtonIcon = "_ma-a";
export var carouselArrowButton = "_ma-6";
export var carouselElementContainer = "_ma-1";
export var left = "_ma-7";
export var productDisplayCarouselContainer = "_ma-0";
export var productTileContainer = "_ma-2";
export var productTileImage = "_ma-4";
export var productTileImageContainer = "_ma-3";
export var productTileTitle = "_ma-5";
export var right = "_ma-8";
export var sliderOverflow = "_ma-c";